var _rect, _path, _path2, _path3, _g, _path4, _rect2, _rect3, _rect4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgServiceEstateStep1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 217,
    viewBox: "0 0 356 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.5908,
    y: 65.1621,
    width: 202.702,
    height: 128.656,
    fill: "#99C4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.107 129.491L235.293 64.9637L235.293 194.018L138.107 129.491Z",
    fill: "#B4D6FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.776 129.491L32.5903 64.9637L32.5903 194.018L129.776 129.491Z",
    fill: "#B4D6FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.149 144.194C138.735 149.817 129.148 149.817 122.735 144.194L32.5906 65.1637H235.293L145.149 144.194Z",
    fill: "#E0EEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_368_742)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.001,
    y: 5,
    width: 155.498,
    height: 199,
    rx: 4,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.501,
    y: 5.5,
    width: 154.498,
    height: 198,
    rx: 3.5,
    stroke: "#EFF3F8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M252.242 36.2344V54.1641H249.566V45.2969H248.16V53.3047H245.543V36.5078H248.16V43.0508H249.566V36.2344H252.242ZM237.418 49.8672V38.168H240.23V47.4258C241.568 47.377 243.043 47.25 244.625 46.9375L244.898 49.3594C242.535 49.7695 240.484 49.8867 238.668 49.8672H237.418ZM270.387 44.6133V46.8594H254.039V44.6133H257.594V42.5723C256.334 41.9863 255.611 41.0977 255.621 39.9648C255.611 37.7969 258.199 36.4785 262.203 36.4688C266.188 36.4785 268.775 37.7969 268.785 39.9648C268.775 41.127 268.033 42.0254 266.715 42.6113V44.6133H270.387ZM255.875 50.8828C255.875 48.793 258.238 47.6406 262.184 47.6406C266.061 47.6406 268.434 48.793 268.434 50.8828C268.434 53.002 266.061 54.1445 262.184 54.1445C258.238 54.1445 255.875 53.002 255.875 50.8828ZM258.551 39.9648C258.531 40.8633 259.811 41.2734 262.203 41.2734C264.576 41.2734 265.875 40.8633 265.875 39.9648C265.875 39.0664 264.576 38.627 262.203 38.6367C259.811 38.627 258.531 39.0664 258.551 39.9648ZM258.746 50.8828C258.727 51.6836 259.83 52.0645 262.184 52.0547C264.479 52.0645 265.611 51.6836 265.621 50.8828C265.611 50.0918 264.479 49.7598 262.184 49.75C259.83 49.7598 258.727 50.0918 258.746 50.8828ZM260.445 44.6133H263.902V43.2949C263.375 43.3535 262.799 43.3828 262.203 43.3828C261.578 43.3828 260.992 43.3535 260.445 43.2949V44.6133ZM287.672 44.418V46.6641H271.324V44.418H287.672ZM271.969 41.7031C275.299 41.4102 276.891 40.3359 277.369 39.2812H272.809V37.0352H286.188V39.2812H281.588C282.066 40.3262 283.648 41.4102 287.047 41.7031L286.07 43.8906C282.574 43.5781 280.406 42.3281 279.469 40.668C278.541 42.3281 276.412 43.5781 272.906 43.8906L271.969 41.7031ZM273.16 50.8242C273.16 48.7148 275.533 47.4844 279.469 47.4844C283.365 47.4844 285.719 48.7148 285.719 50.8242C285.719 52.9629 283.365 54.1836 279.469 54.1641C275.533 54.1836 273.16 52.9629 273.16 50.8242ZM276.031 50.8242C276.012 51.6641 277.115 51.9961 279.469 51.9961C281.764 51.9961 282.896 51.6641 282.906 50.8242C282.896 50.0039 281.764 49.6523 279.469 49.6523C277.115 49.6523 276.012 50.0039 276.031 50.8242ZM303.785 36.2344V46.7031H300.992V44.5938H297.926V45.8242H289.332V37.543H297.926V38.7734H300.992V36.2344H303.785ZM291.402 50.668C291.402 48.4512 293.766 47.1426 297.594 47.1523C301.471 47.1426 303.834 48.4512 303.844 50.668C303.834 52.9043 301.471 54.1836 297.594 54.1641C293.766 54.1836 291.402 52.9043 291.402 50.668ZM292.125 43.5977H295.172V39.75H292.125V43.5977ZM294.195 50.668C294.195 51.5957 295.357 52.0449 297.594 52.0547C299.879 52.0449 301.031 51.5957 301.051 50.668C301.031 49.6914 299.879 49.2812 297.594 49.2812C295.357 49.2812 294.195 49.6914 294.195 50.668ZM297.926 42.3281H300.992V40.9609H297.926V42.3281Z",
    fill: "#374969"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 81,
    width: 118,
    height: 6,
    rx: 3,
    fill: "#DFDFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 105,
    width: 118,
    height: 6,
    rx: 3,
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 129,
    width: 118,
    height: 6,
    rx: 3,
    fill: "#DFDFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 153,
    width: 84,
    height: 6,
    rx: 3,
    fill: "#DFDFDF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_368_742",
    x: 182.001,
    y: 0,
    width: 173.498,
    height: 217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_368_742"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_368_742"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_368_742",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgServiceEstateStep1);
export default __webpack_public_path__ + "static/media/ImgServiceEstateStep1.71ede1d16e796b97ca19d13891567b0e.svg";
export { ForwardRef as ReactComponent };